import {NgClass, NgOptimizedImage} from "@angular/common";
import {Component, input, output} from '@angular/core';
import {NgbDateStruct, NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {TranslateModule, TranslateService} from "@ngx-translate/core";
import {catchError, map, of} from 'rxjs';
import {dateUtils} from "../../../../../../helpers/date.utils";
import {PlanningRegion, ProgRegionItem} from "../../../../../../models/planning_region.model";
import {Screen} from "../../../../../../models/screen.model";
import {PlanningRegionApiService} from "../../../../../../services/api/planning-region-api.service";
import {PlanningRegionService} from "../../../../../../services/planning-region.service";
import {ToastService} from "../../../../../../services/toaster.service";
import {BaseComponent} from "../../../../../../shared/base/base.component";
import {
  PlanningRegionEditReservationModalComponent
} from "../../../../../../shared/modals/planning-region/planning-region-edit-reservation-modal/planning-region-edit-reservation-modal.component";
import {
  RemoveModalComponent
} from "../../../../../../shared/modals/planning-region/planning-region-remove-reser-modal/remove-modal.component";

@Component({
  selector: '[app-planning-region-cell]',
  standalone: true,
  imports: [
    TranslateModule,
    NgClass,
    NgOptimizedImage
  ],
  templateUrl: './planning-region-cell.component.html',
  styleUrl: './planning-region-cell.component.scss'
})
export class PlanningRegionCellComponent extends BaseComponent {
  programme = input.required<ProgRegionItem>();
  data = input.required<PlanningRegion>()
  screen = input.required<Screen>()
  dateValue = input.required<NgbDateStruct>()
  wednesday = input.required<string>()
  reloadProgrammes = output<boolean>()

  constructor(
    private modalService: NgbModal,
    private translate: TranslateService,
    private planningRegionApiService: PlanningRegionApiService,
    private toastService: ToastService,
    protected planningRegionService: PlanningRegionService,
  ) {
    super();
  }

  openProgrammeModal(id_reser: number): void {
    if (id_reser){
      const modalRef = this.modalService.open(PlanningRegionEditReservationModalComponent,
        {
          size: 'xl',
          centered: true,
        }
      );
      modalRef.componentInstance.date = this.dateValue();
      modalRef.componentInstance.id_reser = id_reser;
      modalRef.componentInstance.title = 'editReservationModal.modalHeader.title';
    }
  }

  getVersionsByIdReser(id_reser: number): string {
    return this.data().versions[id_reser]?.replace(/,\s*$/, '') || '';
  }

  removeProgramme(event: Event, programme: ProgRegionItem): void {
    event.stopPropagation();
    const modalRef = this.modalService.open(RemoveModalComponent, {
      size: 'lg',
      centered: true,
    });
    modalRef.componentInstance.title = this.translate.instant('removeModal.modalHeader.title');
    modalRef.componentInstance.body = this.translate.instant('removeModal.reservation.body', {
      num_semaine: programme.week_infos.num_semaine,
      nom_film: programme.film_infos.nom_film,
    });
    modalRef.componentInstance.confirmButtonText = this.translate.instant('removeModal.confirmButton');
    modalRef.componentInstance.cancelButtonText = this.translate.instant('removeModal.cancelButton');

    modalRef.closed.subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.removeReser(programme);
      }
    });
  }

  isAvp(programme: ProgRegionItem): boolean {
    return this.isDateBefore(programme.film_infos.date_sortie);
  }

  isSn(programme: ProgRegionItem): boolean {
    const selectedDate = dateUtils.fromDateStrToDate(this.wednesday());
    const sortieDate = dateUtils.fromDateStrToDate(programme.film_infos.date_sortie);
    return selectedDate.toISOString() == sortieDate.toISOString();
  }

  isAnnounced(cinemaId: number): boolean {
    const progAnnonceDate = this.data().prog_annonce[cinemaId];
    return progAnnonceDate ?
      dateUtils.fromDateStrToDate(progAnnonceDate) >= dateUtils.fromDateStrToDate(this.wednesday())
      : false;
  }

  private isDateBefore(dateStr: string): boolean {
    const selectedDateObj = dateUtils.fromDateStrToDate(this.wednesday());
    const dateToCompareObj =  dateUtils.fromDateStrToDate(dateStr);
    return selectedDateObj < dateToCompareObj;
  }

  private removeReser(prog: ProgRegionItem): void {
    const wedn = this.wednesday();
    this.planningRegionApiService.removeReservation(this.cookies, prog.id_reser, wedn).pipe(
      map(() => {
        this.toastService.showSuccess('toast.success');
        this.reloadProgrammes.emit(true);
        return this.planningRegionApiService.reloadPlanningRegion(this.idRegion);
      }),
      catchError((e)=> {
        this.toastService.showDanger('toast.error')
        return of(e)
      })
    ).subscribe()
  }
}
